export enum ResultEnum {
  /**
   * 正常状态
   */
  SUCCESS = `0,200`,
  /**
   * 未登录（临时code）
   */
  NOTLOGININ = 1406000,
  // 错误Code 页面内容为空
  ERRORNOTFOUND = 1000007,
}

export enum SaleStatusColor {
  // 待售
  FORSALE = 'blue',
  // 在售
  ONSALE = 'green',
  // 售完
  SOLD = 'gray',
}
